<div class="container" *ngIf="networkError">
  <h1 *ngIf='networkError.status === 401' class='success'>Connected</h1>
  <h1 *ngIf='networkError.status !== 401' class='error'>Error</h1>
  <p>Status Code: {{ networkError.status }}</p>
  <p>Error: {{ networkError.name }}</p>
  <p>Url: {{ networkError.url }}</p>
</div>
